module.exports = __webpack_public_path__ + "img/resource-tech-image-68.5c241c35.jpg";